import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"  viewBox="0 0 1080.000000 1080.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd"  transform="translate(0.000000,1080.000000) scale(0.100000,-0.100000)">

<path d="M5075 9893 c-403 -28 -798 -102 -1145 -215 -328 -106 -597 -225 -875
-385 -162 -94 -167 -97 -179 -106 -6 -5 -40 -27 -76 -51 -135 -88 -430 -310
-460 -345 -3 -3 -25 -24 -50 -45 -99 -86 -299 -287 -414 -415 -52 -58 -260
-320 -281 -354 -5 -9 -46 -69 -89 -134 -128 -190 -183 -286 -289 -498 -237
-476 -372 -931 -449 -1510 -20 -151 -22 -212 -22 -540 0 -292 4 -396 17 -495
60 -439 135 -750 265 -1102 100 -269 215 -508 370 -768 48 -80 201 -312 212
-320 3 -3 17 -21 30 -40 171 -250 550 -641 830 -859 47 -36 91 -72 99 -79 8
-8 32 -26 54 -40 51 -35 69 -47 149 -104 36 -27 69 -48 72 -48 4 0 22 -11 39
-24 111 -82 583 -320 797 -401 365 -139 751 -232 1160 -280 277 -32 784 -30
1040 6 491 68 874 172 1290 350 80 34 386 188 445 222 238 142 568 372 661
461 6 6 38 33 70 61 32 27 124 112 203 190 367 359 646 739 881 1200 47 94 93
188 102 210 9 22 35 85 58 140 141 340 247 741 300 1135 41 301 48 770 16
1055 -82 720 -304 1377 -659 1945 -77 123 -130 205 -137 210 -4 3 -25 32 -47
65 -34 50 -110 151 -191 251 -162 202 -492 519 -738 710 -145 113 -363 258
-497 333 -511 284 -876 421 -1407 530 -346 71 -832 106 -1155 84z m590 -374
c1593 -139 2977 -1166 3580 -2654 135 -334 224 -676 277 -1068 19 -141 22
-209 23 -517 0 -231 -4 -392 -13 -460 -99 -805 -373 -1497 -837 -2115 -344
-457 -799 -858 -1290 -1136 -520 -295 -1030 -461 -1640 -536 -212 -26 -769
-26 -965 0 -181 24 -388 62 -540 98 -260 63 -670 215 -895 332 -108 56 -286
157 -338 191 -29 18 -69 43 -90 55 -21 13 -43 28 -50 35 -6 7 -41 32 -77 56
-36 24 -101 72 -145 107 -44 35 -89 71 -100 80 -175 139 -461 433 -641 659
-68 87 -212 293 -250 359 -6 11 -37 62 -68 114 -190 312 -373 763 -460 1131
-164 692 -165 1365 -2 2030 77 313 181 598 322 883 90 182 114 224 241 424
252 396 617 790 1007 1087 185 141 447 301 685 421 684 342 1487 492 2266 424z"/>
<path d="M5135 9019 c-192 -21 -396 -92 -555 -194 -60 -38 -67 -47 -83 -97
-19 -60 -21 -85 -9 -90 4 -1 43 -56 86 -120 43 -64 83 -121 89 -126 7 -5 34
-17 61 -26 44 -14 52 -14 72 -1 124 81 285 144 424 166 93 14 292 6 375 -16
192 -51 435 -257 534 -453 32 -63 19 -63 -17 0 -68 122 -199 247 -328 314 -81
42 -294 111 -381 124 -37 5 -93 10 -124 10 -58 0 -234 -32 -266 -49 -10 -5
-52 -25 -94 -45 -90 -43 -110 -63 -134 -133 l-19 -52 83 -125 c46 -68 90 -131
99 -139 10 -8 41 -22 70 -32 28 -9 52 -19 52 -22 0 -3 -13 -22 -28 -42 -35
-44 -90 -192 -98 -265 -4 -36 -1 -71 10 -108 14 -50 16 -184 16 -1315 -1 -880
-4 -1253 -11 -1240 -11 18 -39 90 -186 477 -46 124 -110 290 -140 370 -31 80
-66 172 -78 205 -42 111 -195 510 -206 534 -5 13 -55 144 -111 290 -80 213
-261 688 -285 749 -4 10 -60 12 -251 10 l-245 -3 -62 -165 c-56 -147 -175
-462 -355 -935 -33 -88 -65 -169 -70 -180 -5 -11 -24 -58 -41 -105 -49 -131
-86 -230 -107 -285 -11 -27 -71 -187 -135 -355 -131 -346 -205 -542 -272 -715
-26 -66 -55 -142 -65 -170 -10 -27 -35 -93 -56 -145 -20 -52 -49 -129 -64
-170 -16 -41 -37 -97 -48 -125 -123 -321 -322 -852 -322 -862 0 -10 57 -13
276 -13 l275 0 13 33 c8 17 35 91 61 162 26 72 60 164 75 205 15 41 66 183
114 315 47 132 99 274 114 315 l28 75 887 3 887 2 10 -22 c5 -13 34 -90 64
-173 221 -606 299 -826 305 -865 l6 -45 293 -3 c166 -1 292 2 292 7 0 5 -7 25
-15 44 -13 32 -15 163 -15 972 l0 935 1070 0 1070 0 0 -980 0 -980 275 0 275
0 0 2115 0 2115 -275 0 -275 0 0 -910 0 -910 -1070 0 -1070 0 0 768 0 768 31
30 c43 40 99 163 125 271 3 11 66 33 181 62 40 11 42 14 60 74 l19 62 -23 58
c-68 176 -186 276 -421 354 -96 32 -118 36 -212 36 -95 0 -139 -6 -192 -28
-10 -4 -18 -3 -18 2 0 12 87 39 174 54 93 16 237 7 304 -19 76 -29 207 -127
262 -197 52 -65 108 -163 134 -235 16 -42 22 -47 75 -66 l58 -21 119 38 c211
67 194 57 217 126 l20 60 -29 74 c-24 63 -75 166 -102 205 -96 145 -240 279
-384 359 -80 44 -304 126 -413 151 -60 14 -117 19 -230 18 -130 0 -164 -4
-253 -27 -56 -15 -134 -42 -173 -60 -38 -19 -68 -29 -66 -23 10 33 264 119
405 137 112 14 314 7 427 -16 88 -17 248 -90 343 -156 199 -138 345 -318 445
-544 22 -49 43 -93 46 -98 4 -4 33 -15 64 -24 84 -24 107 -11 131 72 21 74 21
72 -49 215 -134 273 -334 475 -605 610 -84 42 -301 120 -400 144 -143 34 -308
43 -465 25z m460 -82 c399 -88 719 -321 915 -667 40 -72 100 -209 100 -231 0
-14 -71 -42 -80 -32 -4 4 -19 40 -34 78 -127 326 -415 600 -751 713 -157 53
-243 67 -425 67 -139 0 -180 -4 -260 -23 -140 -35 -321 -108 -377 -154 -9 -7
-3 -25 25 -70 20 -33 42 -62 48 -65 7 -2 40 10 73 27 70 35 200 82 281 102 35
8 116 13 225 12 151 0 181 -3 268 -27 351 -94 624 -342 752 -683 14 -37 22
-71 17 -76 -11 -11 -314 -108 -322 -103 -4 3 -15 26 -25 52 -57 155 -176 302
-312 386 -102 63 -256 107 -374 107 -97 0 -223 -27 -307 -65 l-72 -34 30 -48
c60 -95 48 -91 147 -57 77 25 102 29 198 28 86 0 124 -5 175 -22 128 -45 221
-118 300 -238 43 -66 80 -158 68 -170 -3 -2 -54 -18 -114 -35 -139 -38 -139
-38 -136 -80 2 -19 -7 -65 -18 -103 -83 -267 -455 -288 -572 -31 -34 75 -32
181 5 258 30 59 84 113 146 144 56 28 212 26 268 -5 46 -24 91 -64 118 -105 9
-15 22 -27 28 -27 31 0 157 45 157 56 0 22 -56 98 -107 145 -54 50 -134 93
-214 114 -108 29 -211 15 -332 -46 -43 -21 -80 -39 -82 -39 -8 0 -185 270
-185 282 0 7 28 30 63 50 237 141 524 156 781 39 165 -75 326 -235 397 -396
11 -25 26 -45 33 -45 19 0 129 39 139 49 10 10 -46 126 -100 208 -85 130 -282
291 -427 350 -155 64 -220 76 -391 76 -134 1 -173 -3 -240 -21 -105 -29 -194
-66 -281 -119 -39 -24 -74 -43 -76 -43 -10 0 -188 268 -188 283 0 19 53 53
176 115 114 57 256 104 364 122 41 6 82 13 90 15 39 10 351 -4 415 -18z m-107
-943 c57 -28 152 -115 152 -139 0 -21 -14 -19 -36 6 -10 12 -32 30 -47 41 -44
32 -195 80 -272 87 l-70 7 45 11 c85 21 170 16 228 -13z m-1752 -1179 c13 -33
89 -242 170 -465 81 -223 160 -441 177 -485 16 -44 41 -116 57 -160 15 -44 74
-206 131 -360 148 -403 149 -409 144 -422 -6 -17 -1410 -19 -1420 -2 -4 6 0
29 8 52 40 110 196 539 402 1107 124 344 241 664 258 712 18 49 36 87 41 85 5
-2 19 -30 32 -62z"/>
<path d="M5223 7806 c-153 -72 -154 -299 -2 -377 91 -46 216 -15 274 69 27 39
30 51 30 120 0 68 -3 82 -29 119 -36 53 -111 93 -175 93 -27 0 -67 -10 -98
-24z m168 -79 c46 -31 61 -62 56 -121 -4 -42 -10 -55 -41 -83 -30 -27 -44 -33
-82 -33 -89 0 -141 58 -131 146 11 99 115 147 198 91z"/>
<path d="M3193 3083 c-10 -3 -13 -66 -13 -265 l0 -260 108 3 c100 4 113 7 158
34 72 44 104 111 104 221 0 134 -44 216 -134 248 -42 15 -201 28 -223 19z
m223 -73 c45 -28 67 -77 72 -158 2 -42 -1 -96 -7 -120 -22 -81 -96 -127 -191
-120 l-45 3 -3 200 c-1 110 -1 204 2 210 5 14 144 3 172 -15z"/>
<path d="M6261 3072 c-15 -28 8 -57 38 -47 17 5 21 13 19 33 -4 34 -42 43 -57
14z"/>
<path d="M4070 2995 c0 -45 0 -45 -35 -45 -31 0 -35 -3 -35 -25 0 -22 4 -25
35 -25 l35 0 0 -137 c0 -151 8 -179 53 -201 40 -19 89 -7 85 21 -2 16 -11 23
-33 25 -16 2 -33 9 -37 15 -4 7 -8 72 -8 145 l0 132 35 0 c31 0 35 3 35 25 0
22 -4 25 -35 25 -35 0 -35 0 -35 45 0 43 -1 45 -30 45 -29 0 -30 -2 -30 -45z"/>
<path d="M7321 2949 c-52 -11 -79 -29 -96 -65 -33 -69 2 -111 125 -151 82 -27
85 -29 88 -61 4 -41 -9 -58 -50 -66 -48 -10 -100 9 -120 44 -17 29 -50 40 -63
20 -9 -15 21 -66 52 -88 64 -45 162 -35 220 23 37 37 41 63 16 106 -18 30 -49
48 -118 69 -89 26 -95 30 -95 65 0 35 12 49 49 58 41 10 83 -4 100 -34 11 -21
24 -29 44 -29 15 0 27 5 27 10 0 21 -30 69 -49 79 -33 18 -95 27 -130 20z"/>
<path d="M3715 2935 c-35 -18 -65 -51 -65 -71 0 -25 49 -16 75 14 19 22 31 27
70 27 57 0 88 -30 83 -79 -3 -30 -5 -31 -53 -34 -86 -4 -114 -12 -150 -44 -30
-26 -35 -36 -35 -75 0 -37 5 -50 33 -77 46 -47 96 -54 158 -23 46 22 49 23 55
5 4 -12 15 -18 36 -18 30 0 30 1 24 38 -3 20 -6 91 -6 157 0 118 -1 122 -29
155 -26 32 -33 34 -97 38 -49 2 -78 -2 -99 -13z m165 -227 c0 -24 -4 -48 -8
-54 -44 -63 -172 -55 -172 12 0 60 32 82 123 83 l57 1 0 -42z"/>
<path d="M4357 2936 c-32 -18 -66 -55 -67 -73 0 -24 50 -14 74 14 18 21 32 26
68 27 61 1 90 -24 86 -73 l-3 -36 -77 -6 c-90 -8 -142 -37 -153 -89 -23 -104
78 -176 181 -130 56 24 64 25 64 5 0 -10 10 -15 31 -15 l32 0 -7 46 c-3 26 -6
98 -6 160 0 111 -1 114 -29 146 -26 29 -35 33 -97 36 -48 2 -77 -2 -97 -12z
m163 -225 c0 -53 -8 -69 -41 -86 -84 -44 -168 13 -128 86 14 28 44 38 112 38
l57 1 0 -39z"/>
<path d="M4933 2935 c-33 -14 -63 -59 -63 -96 0 -32 60 -86 111 -98 105 -27
114 -33 114 -76 0 -36 -3 -40 -38 -54 -50 -19 -106 -3 -129 37 -16 27 -47 36
-64 19 -13 -12 17 -62 49 -83 70 -45 158 -40 213 11 28 26 34 40 34 73 0 53
-36 84 -130 112 -96 29 -117 52 -85 96 30 44 134 33 150 -15 4 -15 15 -21 36
-21 16 0 29 5 29 10 0 25 -32 71 -60 85 -36 19 -124 19 -167 0z"/>
<path d="M5320 2928 c-107 -73 -108 -273 -3 -344 43 -29 94 -37 142 -24 44 12
91 45 91 65 0 23 -28 24 -56 3 -39 -31 -115 -30 -148 1 -29 28 -50 75 -42 96
4 12 28 15 131 15 l125 0 0 47 c0 64 -32 127 -74 147 -50 24 -126 21 -166 -6z
m125 -33 c35 -14 55 -46 55 -86 0 -17 -8 -19 -100 -19 -55 0 -100 2 -100 5 0
2 7 22 16 44 10 26 27 45 47 55 39 19 40 19 82 1z"/>
<path d="M5647 2943 c-4 -3 -7 -91 -7 -195 l0 -188 30 0 30 0 0 129 c0 71 4
141 10 155 10 29 57 56 95 56 20 0 25 5 25 25 0 22 -4 25 -33 25 -18 0 -42 -7
-53 -15 -25 -19 -44 -19 -44 0 0 15 -40 21 -53 8z"/>
<path d="M5870 2936 c0 -12 88 -263 122 -348 7 -19 18 -28 33 -28 20 0 29 20
89 188 36 103 66 191 66 195 0 5 -12 7 -27 5 -26 -3 -31 -11 -73 -139 -25 -75
-49 -137 -54 -138 -6 -1 -25 42 -43 96 -64 187 -62 183 -89 183 -14 0 -24 -6
-24 -14z"/>
<path d="M6260 2755 l0 -195 30 0 30 0 0 195 0 195 -30 0 -30 0 0 -195z"/>
<path d="M6500 2928 c-98 -67 -103 -272 -9 -341 38 -27 97 -38 143 -26 76 21
143 119 81 119 -18 0 -28 -7 -35 -25 -24 -64 -137 -67 -173 -5 -38 64 -30 188
14 229 48 45 138 28 158 -30 7 -22 16 -29 35 -29 30 0 33 17 11 61 -36 69
-156 94 -225 47z"/>
<path d="M6893 2930 c-63 -38 -98 -157 -73 -249 32 -119 185 -168 277 -88 26
23 31 32 22 43 -15 18 -22 18 -49 -6 -58 -50 -148 -29 -183 43 -32 63 -25 67
124 67 l132 0 -6 50 c-13 109 -63 160 -158 160 -36 0 -65 -7 -86 -20z m155
-56 c12 -14 22 -38 22 -55 l0 -29 -95 0 c-93 0 -95 0 -95 24 0 28 34 74 64 86
32 13 78 1 104 -26z"/>
</g>
</svg>

    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
